import { useEffect, useCallback } from 'react';

export default ({ onPaste }) => {
  const handlePaste = useCallback(
    (event) =>
      onPaste &&
      onPaste((event.clipboardData || window.clipboardData).getData('Text')),
    [onPaste]
  );

  useEffect(() => {
    document.addEventListener('paste', handlePaste);
    return () => {
      document.removeEventListener('paste', handlePaste);
    };
  }, [handlePaste]);
};
